import { AuthContext, AuthContextModel } from '@contexts/auth-context';
import { useContext } from 'react';

export function useAuth(): AuthContextModel {
    return useContext(AuthContext);
}
